import * as React from 'react';
import DynamicLeftAxisPart from './DynamicLeftAxisPart';
import { VELOCITY } from '../../OnlinePanel/Widgets/SpeedWidget';

interface IProps {
  isDetail: boolean;
  colors: string[];
  colorBoundaries: number[];
  maxValue: number;
  detailValues?: boolean;
  name?: string;
}

export default function DynamicLeftAxis(props: IProps) {
  const getHeight = (index: number) => {
    if (!props.isDetail && props.name === VELOCITY) {
      return (props.colorBoundaries[index] * 100) / (props.maxValue + 1);
    }
    return (props.colorBoundaries[index] * 100) / props.maxValue;
  };

  return (
    <div>
      {props.colors.map((value: string, index: number) => {
        return (
          <DynamicLeftAxisPart
            isDetail={props.isDetail}
            color={value}
            colorBoundaryValue={props.colorBoundaries[index]}
            zIndex={index}
            height={`${getHeight(index)}%`}
            colorBoundaries={props.colorBoundaries}
            detailValues={props.detailValues}
          />
        );
      })}
    </div>
  );
}
